module.exports = __webpack_public_path__ + "img/icon_sites.b96eb8d1.svg";